import { Button, Modal } from '@lego/connect-components-react';
import { Text } from '@lego/klik-ui';
import type { RefObject } from 'react';

type MassRevertModalProps = {
  isOpen: boolean;
  selectedRowsCount: number;
  hasCommentColumn?: boolean;
  triggerRef: RefObject<HTMLButtonElement | null>;
  onClose: () => void;
  onSubmit: () => void;
};

const MassRevertModal = ({
  isOpen,
  selectedRowsCount,
  hasCommentColumn,
  triggerRef,
  onClose,
  onSubmit,
}: MassRevertModalProps) => {
  const productText = selectedRowsCount === 1 ? 'product' : 'products';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      triggerRef={triggerRef}
    >
      <Modal.Title>Revert edits</Modal.Title>
      <Modal.Content>
        <Text className={'body-sm-regular'}>
          {selectedRowsCount} {productText} selected
        </Text>
        {hasCommentColumn ? (
          <Text className={'body-md-regular'}>
            All edited values for the selected {productText} will be reverted,{' '}
            <span className={'body-md-medium'}>except for your comments.</span>
          </Text>
        ) : (
          <Text className={'body-md-medium'}>
            All edited values for the selected {productText} will be reverted.
          </Text>
        )}
      </Modal.Content>
      <Modal.Footer>
        <Button appearance="ghost" variant="neutral" onClick={onClose}>
          Cancel
        </Button>
        <Button
          appearance="solid"
          onClick={() => {
            onSubmit();
            onClose();
          }}
        >
          Revert
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MassRevertModal;
